import type { TournamentWithHierarchyBySportId } from 'app/redux/betting-presentation/grid/selectors';

export type GetTournamentsBySportIdsSortingByPriorityProps = TournamentWithHierarchyBySportId;
export const getTournamentsBySportIdsSortingByPriority =
  (tournamentsBySportIds: GetTournamentsBySportIdsSortingByPriorityProps) => {
    const sportIds = Array.from(tournamentsBySportIds.keys()).sort((a, b) => {
      const aSport = tournamentsBySportIds.get(a)?.values().next().value.sport;
      const bSport = tournamentsBySportIds.get(b)?.values().next().value.sport;

      return (
        (bSport.priority - aSport.priority)
        || (aSport.name.localeCompare(bSport.name, 'en'))
        || (aSport?.globalPriority
          ? aSport?.globalPriority.localeCompare(bSport?.globalPriority)
          : 0)
      );
    });

    const tournamentsBySportIdsSortingByPriority = new Map();

    for (const key of sportIds) {
      tournamentsBySportIdsSortingByPriority.set(key, tournamentsBySportIds.get(key));
    }

    return tournamentsBySportIdsSortingByPriority;
  };
